var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('topbar'),_c('top-menu'),_c('div',{staticClass:"main-container-home"},[_c('app-main')],1),_c('footer-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }